import React, { useEffect, useRef, useState } from 'react'
import { WebLink } from '../data/LinkData';
import { ReactComponent as ArrowDown } from '../icon/arrow-down.svg';
import { ReactComponent as ArrowUp } from '../icon/arrow-up.svg';
import LinkDataSplitter from './LinkDataSplitter';
import AnimateHeight from 'react-animate-height';


const ExpandedLink: React.FC<{ text: string, img: string, data: WebLink[] }> = ({ text, img, data }) => {
    const [click, setClick] = React.useReducer((state) => !state, false);
    const [height, setHeight] = useState<string | number>(0);


    return <>
        <button className='button'
            aria-expanded={height !== 0}

            aria-controls="panel"
            onClick={() => {
                setClick()
                setHeight(height === 0 ? 'auto' : 0)

            }}>
            <img className='buttonImgIcon' src={img}></img>
            <div className='alignDiv'>
                <span>{text}</span>

                {click ? (
                    <ArrowUp stroke='var(--white20)' width={24} height={24} />
                ) : (
                    <ArrowDown stroke='var(--white20)' width={24} height={24} />
                )}


            </div>


        </button>

        <AnimateHeight
            id="panel"
            duration={300}
            height={height as any}
        >
            <div className='internalDiv'>
                <LinkDataSplitter links={data} />
            </div>
        </AnimateHeight>
    </>
}

export default ExpandedLink